import getStream from 'get-stream';
import { Readable } from 'stream';
import csvParser from './csv-parser';

const readCsv = (input, opts) => {
  if (typeof input === 'string' || Buffer.isBuffer(input)) {
    const s = new Readable();
    s.push(input);    // the string you want
    s.push(null);

    input = s;
  }

  console.log('input', input);
  return getStream.array(input.pipe(csvParser(opts)));
};

const getName = (row, columns) => {
  if (columns['contact-name']) {
    return row[columns['contact-name']];
  } else if (columns['contact-first-name'] && columns['contact-last-name']) {
    return `${row[columns['contact-first-name']]} ${row[columns['contact-last-name']]}`;
  }

  return null;
};

const getValue = (row, columns, name) => {
  if (columns[name]) {
    return row[columns[name]];
  }

  return null;
};

const parseTasks = (input, config) => {
  if (config.rowOffset) {
    const lines = input.split('\n');
    // remove one line, starting at the first position
    lines.splice(0, config.rowOffset);
    // join the array back into a single string
    input = lines.join('\n');
  }

  console.log('config', config);
  const { columns } = config;

  return readCsv(input)
    .then((data) => {
      return data.map((row) => {
        return {
          origin: {
            building: getValue(row, columns, 'origin-building'),
            floor: getValue(row, columns, 'origin-floor'),
            space: getValue(row, columns, 'origin-space'),
          },
          destination: {
            building: getValue(row, columns, 'destination-building'),
            floor: getValue(row, columns, 'destination-floor'),
            space: getValue(row, columns, 'destination-space'),
          },
          contact: {
            name: getName(row, columns),
            email: getValue(row, columns, 'contact-email'),
          },
          notes: getValue(row, columns, 'notes'),
        };
      });
    });
};

export {
  parseTasks,
  readCsv,
};



// WEBPACK FOOTER //
// ./src/utils/csv.js